document.addEventListener("turbolinks:load", (event) => {
  let printBtn = document.querySelectorAll("[data-print]");

  printBtn.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      window.print();
    });
  });
});
